import React from "react";

import {
  EditPropertyIcon,
  FontSizeIcon,
  LowercaseIcon,
  RemovePropertyIcon,
  RenameIcon,
  ReplaceIcon,
} from "../components/icons/themes/windows10";
import { DestinationKey, DestinationName } from "../destinations/types";

export type TransformationOperationType =
  | "replaceName"
  | "replacePropertyKey"
  | "castPropertyValue"
  | "uppercasePropertyValue"
  | "lowercasePropertyValue"
  | "deleteProperty";

export const transformationOperations: TransformationOperationType[] = [
  "replaceName",
  "replacePropertyKey",
  "castPropertyValue",
  "uppercasePropertyValue",
  "lowercasePropertyValue",
  "deleteProperty",
];

export const transformationOperationText: Record<
  TransformationOperationType,
  string
> = {
  deleteProperty: "Delete Property",
  replaceName: "Rename Event",
  castPropertyValue: "Change Property Type",
  lowercasePropertyValue: "Lowercase Property Value",
  replacePropertyKey: "Rename Property",
  uppercasePropertyValue: "Uppercase Property Value",
};

type IconElement = React.ForwardRefExoticComponent<any>;
export const transformationOperationIcons: Record<
  TransformationOperationType,
  IconElement
> = {
  castPropertyValue: EditPropertyIcon,
  deleteProperty: RemovePropertyIcon,
  replaceName: RenameIcon,
  replacePropertyKey: ReplaceIcon,
  lowercasePropertyValue: FontSizeIcon,
  uppercasePropertyValue: LowercaseIcon,
};

export type TransformationIntention = "fixBadData" | "standardEvent";

export type LoadTransformationData = {
  ID: string | null;
  targetValue: string | null;
  operation: TransformationOperationType;
  operandValue: string | number | boolean | null;
  enabled: boolean;
  createdAt: string;
  priority: number;
};

export type LoadedTransformationSet = {
  id: string;
  envID: string;
  createdAt: string;
  createdByUserId: string;
  createdByUserEmail: string;
  destinationName: DestinationKey | "ALL_DESTINATIONS_VALUE" | null;
  eventDefId: string | null;
  eventDefName: string | null;
  eventDefEventSource: string;
  description: string;
  intention: TransformationIntention;
  transformations: LoadTransformationData[];
  priority: number;
};

export type GetTransformationSetsResponse = LoadedTransformationSet[];
